var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wizard__container"},[_c('div',{staticClass:"sticky-top"},[_c('wizard-steps')],1),_c('div',{staticClass:"min-h-100 px-3 py-5"},[_c('router-view',{key:_vm.$route.name})],1)]),_c('div',{staticClass:"sticky__bottom wizard__nav-container"},[_c('wizard-navigation')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }